import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import sessionReducer from './reducers/sessionReducer';
import answersReducer from './reducers/answersReducer';
import curriculumReducer from './reducers/curriculumReducer';
import modelingReducer from './reducers/modelingReducer';
import uxReducer from './reducers/uxReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  roundPlay: roundPlayReducer,
  session: sessionReducer,
  answers: answersReducer,
  curriculum: curriculumReducer,
  modeling: modelingReducer,
  ux: uxReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
